import { Box, CircularProgress } from "@mui/material";

const BrandedLoadingIndicator = () => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 64,
          height: 64,
          borderRadius: "50%",
          bgcolor: "primary.main",
          opacity: 0.1,
          animation: "pulse 2s ease-in-out infinite",
          "@keyframes pulse": {
            "0%, 100%": {
              transform: "scale(1)",
              opacity: 0.1,
            },
            "50%": {
              transform: "scale(1.1)",
              opacity: 0.15,
            },
          },
        }}
      />
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 56,
          height: 56,
          borderRadius: "50%",
          bgcolor: "background.paper",
          border: 2,
          borderColor: "primary.main",
        }}
      >
        <img src="/assets/icons/wiKeyIcon3.png" alt="wikey icon 3" width={55} height={35} />
      </Box>
      <CircularProgress
        size={72}
        thickness={2}
        sx={{
          position: "absolute",
          color: "primary.main",
          opacity: 0.3,
        }}
      />
    </Box>
  );
};

export default BrandedLoadingIndicator;
